<template>
  <div class="inline-form">
    <el-select
      v-model="province"
      placeholder="请选择省"
      :disabled="disabled"
      @change="selectProvince"
    >
      <el-option
        v-for="item in provinceList"
        :key="item.code"
        :label="item.text"
        :value="item.code"
      >
      </el-option>
    </el-select>

    <el-select
      v-model="city"
      placeholder="请选择市"
      :disabled="disabled"
      @change="selectCity"
    >
      <el-option
        v-for="item in cityList"
        :key="item.code"
        :label="item.text"
        :value="item.code"
      >
      </el-option>
    </el-select>

    <el-select
      v-model="area"
      placeholder="请选择县/区"
      :disabled="disabled"
      @change="selectArea"
    >
      <el-option
        v-for="item in areaList"
        :key="item.code"
        :label="item.text"
        :value="item.code"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import FormConfig from "../../formConfig"; // 表单配置
import areaConfig from "./areaConfig";
// 省市区
export default {
  name: "Area",
  props: {
    value: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      dataModel: this.value,
      size: FormConfig.config.size,
      province: "", //省
      provinceList: areaConfig.getProvince(), //省 数据列表
      provinceShow: false, //省 下拉框展开状态
      city: "", //市
      cityList: [], //市 数据列表
      cityShow: false, //市 下拉框展开状态
      area: "", //县/区
      areaList: [], //县/区 数据列表
      areaShow: false, //县/区 下拉框展开状态
      selects: {
        //选择的值
        code: "000000",
        label: ["", "", ""]
      },
      //搜索参数
      searchForm: {
        show: false,
        keyWork: "",
        list: [],
        listShow: false
      },
      searchFormInt: {}
    };
  },
  computed: {
    disabled() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.disabled;
      return status;
    }
  },
  watch: {
    value(val) {
      this.init();
    },
    dataModel(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.dataModel = this.value;
      if (!this.value) {
        return;
      }
      let provinceCode = this.value.substring(0, 2) + "0000";
      let province = _.find(this.provinceList, { code: provinceCode }) || {};
      this.province = province.text;
      let cityCode = this.value.substring(0, 4) + "00";
      let cityList = areaConfig.getCity(province);
      let city = _.find(cityList, { code: cityCode }) || {};
      this.city = city.text;
      this.cityList = cityList;
      let areaList = areaConfig.getCity(city);
      let area = _.find(areaList, { code: this.value }) || {};
      this.area = area.text;
      this.areaList = areaList;
    },
    //选择省份
    selectProvince(code) {
      let item = _.find(this.provinceList, { code }) || "";
      if (!item) {
        return;
      }
      this.provinceShow = false;
      this.province = item.text;
      this.cityList = areaConfig.getCity(item);
      this.selects.code = item.code;
      this.selects.label[0] = item.text;
      this.selects.label[1] = "";
      this.selects.label[2] = "";
      this.city = "";
      this.area = "";
      this.onChange();
    },
    //选择市
    selectCity(code) {
      let item = _.find(this.cityList, { code }) || "";
      if (!item) {
        return;
      }
      this.cityShow = false;
      this.city = item.text;
      this.areaList = areaConfig.getArea(item);
      this.selects.code = item.code;
      this.selects.label[1] = item.text;
      this.selects.label[2] = "";
      this.area = "";
      this.onChange();
    },
    //选择区
    selectArea(code) {
      let item = _.find(this.areaList, { code }) || "";
      if (!item) {
        return;
      }
      this.areaShow = false;
      this.area = item.text;
      this.selects.code = item.code;
      this.selects.label[2] = item.text;
      this.onChange();
    },
    //改变地区
    onChange() {
      this.selects.label = this.selects.label.filter(item => item);
      this.$emit("input", this.selects.code);
    }
  }
};
</script>
<style lang="less" scoped>
.inline-form {
  /deep/.el-select {
    margin-right: 10px;
  }
}
</style>
